import { flatMap, has } from "lodash";
import { useReducer } from "react";
import toast from "react-hot-toast";
import api from "../../apis/axiosInterceptor";

interface Developer {
  developerData: object;
  allDeveloperData: any;
  developerByIdData: object;
  developerDocumentData: object;
  constitutionData: object;
  DeveloperEditData: object;
  error: string;
}

const initialArgs: Developer = {
  developerData: {},
  allDeveloperData: [],
  developerByIdData: {},
  developerDocumentData: {},
  constitutionData: {},
  DeveloperEditData: {},
  error: "",
};

const reducer = (state: Developer, action: Developer) => {
  return { ...state, ...action };
};

const useDeveloper = () => {
  const [state, setState] = useReducer(reducer, initialArgs);

  const getDeveloper = async (
    page: string,
    pageSize: string,
    searchValue: string,
    sort: string,
    order: string,
  ) => {
    try {
      const result: any = await api.get(
        `/api/developer/?page=${page}&pageSize=${pageSize}&searchValue=${searchValue}&sort=${sort}&order=${order}`,
      );

      if (result.data.status) {
        const filterRowsData = result.data.data[0]?.rows.map(
          (item: any, index: number) => {
            return { ...item, id: item._id + index };
          },
        );
        const filterFinalData = {
          ...result.data.data[0],
          rows: filterRowsData,
        };
        //console.log("filterFinalData::2:", filterFinalData);
        setState({
          ...state,
          developerData: filterFinalData,
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };

  const getDeveloperById = async (developerId: any) => {
    //console.log("developerId", developerId);

    try {
      const result: any = await api.get(`/api/developer/${developerId}`);

      if (result.data.status) {
        setState({
          ...state,
          developerByIdData: result.data.data,
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const getConstitution = async () => {
    try {
      const result: any = await api.get(`/api/setting/type?type=constitution`);

      if (result.data.status) {
        setState({
          ...state,
          constitutionData: result.data.data,
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const updateDeveloperStatus = async (developerId: string, status: any) => {
    //console.log("developerIddeveloperId", developerId, status);

    try {
      const result: any = await api.post(
        `/api/developer/status/${developerId}`,
        status,
      );

      if (result.data.status) {
        // toast.success(result.data.message);
        toast.success(result.data.message);
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const updateDeveloper = async (param: any) => {
    const paramObj = {
      ...param,
    };

    try {
      const { data } = await api.put(`/api/developer/${param.id}`, paramObj, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (data.status === true) {
        toast.success(data.message);
        setState({
          ...state,
          DeveloperEditData: {},
        });
        return true;
      }
    } catch (error: any) {
      toast.error(error.response.data.message);
      return false;
    }
  };
  const editDeveloper = async (developerId: string) => {
    try {
      const result: any = await api.get(`/api/developer/${developerId}`);

      //console.log("result: ", result.data.data);

      if (result.data.status) {
        setState({ ...state, DeveloperEditData: result.data.data });
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const createDeveloper = async (param: any) => {
    /* const paramObj = {
      companyName: param.companyName,
      contactPersonMobileNo: param.contactPersonMobileNo,
      contactPersonName: param.contactPersonName,
      email: param.email,
      officeAddress: param.officeAddress,
      promoterMobileNo: param.promoterMobileNo,
      promoterName: param.promoterName,
      developerName: param.developerName,
      website: param.website,
      logo: param.logo,
      constitution: param.constitution,
      role: param.role,
      adminUser: param.adminUser,
    };
    console.log("paramObj => ", paramObj); */

    try {
      // const formData = new FormData();
      const result: any = await api.post("/api/developer", param, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      //console.log("resultfromPostApi => ", result);

      if (result.data.status) {
        // toast.success(result.data.message);
        toast.success("Developer has been Added Successfully");
        setState({ ...state, developerData: result.data.data });
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({
        ...state,
        error: error?.response?.data?.message
          ? error?.response?.data?.message
          : error.message,
      });
      return false;
    }
  };
  const getDeveloperDocument = async (developerId: any) => {
    try {
      const result: any = await api.get(
        `/api/document-master/type?type=developer-documents&developer=${developerId}`,
      );

      if (result.data.status) {
        setState({
          ...state,
          developerDocumentData: result?.data?.data,
        });

        return true;
      } else {
        const errorStr = has(result?.data, "errors")
          ? Object(flatMap(result?.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const uploadDeveloperDocument = async (developerDocument: any) => {
    //console.log("developerDocumentdeveloperDocument", developerDocument);

    try {
      const result: any = await api.postForm(
        `/api/developer-document`,
        developerDocument,
      );

      if (result.data.status) {
        toast.success(result.data.message);
        return true;
      } else {
        // const errorStr = has(result.data, "errors")
        //   ? Object(flatMap(result.data))[1].msg
        //   : result.data.message;
        toast.error(result.data.message);
        // setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.response.data.message);
      //setState({ ...state, error: error.message });
      return false;
    }
  };
  const deleteDeveloperDocument = async (developerId: string) => {
    //console.log("developerIddeveloperId", developerId);
    try {
      const { data } = await api.delete(
        `/api/developer-document/${developerId}`,
      );

      if (data.status === true) {
        toast.success(data.message);
        return true;
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.info("error => ", error);
      return false;
    }
  };

  /* All Developer List Api Start */
  const getAllDeveloperData = async () => {
    try {
      const result: any = await api.get("api/developer/all");
      //console.log("resultAllDeveloper => ", result);

      if (result.data.status) {
        const filterAllDeveloperData = result.data.data.map((item: any) => {
          return { ...item, id: item._id, name: item.companyName };
        });

        //console.log("filterAllDeveloperData>>>", filterAllDeveloperData);

        setState({
          ...state,
          allDeveloperData: filterAllDeveloperData,
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const shareDeveloperDocument = async (shareDocument: any) => {
    try {
      const result: any = await api.post(
        `/api/developer-document/sendDocument`,
        shareDocument,
      );

      if (result.data.status) {
        toast.success(result.data.message);
        return { status: true, data: result.data.data };
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.response.data.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };
  /* All Developer List Api End */

  return {
    getDeveloper,
    updateDeveloper,
    updateDeveloperStatus,
    editDeveloper,
    createDeveloper,
    getDeveloperById,
    getConstitution,
    uploadDeveloperDocument,
    deleteDeveloperDocument,
    getDeveloperDocument,
    getAllDeveloperData,
    shareDeveloperDocument,
    ...state,
  };
};

export default useDeveloper;
